/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { businessConstants } from '../../../../constants/business.constants';
import { AppState } from '../../../../redux';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import { ContactTemplateType } from '../../../contact-dialog-new/contact-dialog.model';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';

@Component({
    selector: 'tam-contact-single-dropdown',
    templateUrl: './contact-single-dropdown.component.html',
    styleUrls: ['./contact-single-dropdown.component.scss'],
    standalone: false
})
export class ContactSingleDropdownComponent implements OnInit, OnDestroy {
    @Input() childConfig: any;
    config: any;
    selectedItem: any;
    suggestionItems = [];
    hintContent = '';
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(private _store: Store<AppState>,
        private _contactTemplateService: ContactTemplateService) { }

    ngOnInit() {
        this._initData();
        if (this.config.action === ContactTemplateType.EditContact) {
            this._initEditValue();
        }
        this._changeValueSet(false);
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    valueChange(item) {
        this.hintContent = '';
        this._contactTemplateService.changeValueStatus = true;
        this._changeValueSet(true);
    }

    /**
   *
   *
   * @private
   * @memberof ContactInputComponent
   */
    private _initData() {
        this.config = this.childConfig.config;
        this.suggestionItems = this.childConfig.dataSource.map(item => item.name);
        this._destroySubscriptions.push(
            this._contactTemplateService.validInputSubject$.subscribe((res) => {
                if (this.config.prefixId === res.prefixId && !this.selectedItem && this.config.isRequired) {
                    this.hintContent = businessConstants.tip;
                }
            }));
    }

    /**
     *init edit value
     *
     * @private
     * @memberof ContactInputComponent
     */
    private _initEditValue() {
        this.selectedItem = this.config.editValue;
        this._changeValueSet(false);
    }

    /**
     * set value to store or valuechangeSubject
     *
     * @param {boolean} isFromUser
     * @memberof ContactInputComponent
     */
    _changeValueSet(isFromUser: boolean = false) {
        if (!this.selectedItem) {
            this.selectedItem = '';
        }
        const value = new ContactTemplateControlValue(this.selectedItem, this.config.controlType,
            this.config, isFromUser);
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }
}
